import React from 'react'

function Settings() {
  return <h1 className="text-6xl">{'<Settings />'}</h1>
}

export default Settings
